import en from './en';
import zh from './zh';
import es from './es';
import de from './de';
import fr from './fr';
import ja from './ja';
import ko from './ko';

/** All available message catalogs, keyed by locale code. */
export const messages: Record<string, Record<string, string>> = {
  en,
  zh,
  es,
  de,
  fr,
  ja,
  ko,
};

export interface LocaleOption {
  /** BCP-47-ish locale code used by react-intl and stored in state. */
  code: string;
  /** Native name (autonym) shown in the language switcher. */
  label: string;
}

/** Locales offered in the UI language switcher, in display order. */
export const LOCALES: LocaleOption[] = [
  { code: 'en', label: 'English' },
  { code: 'zh', label: '简体中文' },
  { code: 'es', label: 'Español' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
];

export const DEFAULT_LOCALE = 'en';

const LOCALE_STORAGE_KEY = 'xtm-go-locale';

/** Persists the chosen locale so it survives a page reload. */
export function persistLocale(code: string): void {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, code);
  } catch {
    // Ignore storage errors (private mode, disabled storage, etc.).
  }
}
